export enum AuthTypeAction {
    CLEAN_AUTH_ERROR = "CLEAN_AUTH_ERROR",
    LOGIN_ERROR = "LOGIN_ERROR",
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    SIGN_UP_ERROR = "SIGN_UP_ERROR",
    SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS",
    SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS",
}
